import React from "react";
import { useNavigate } from "react-router-dom";
// Material Dashboard 2 PRO React TS components
import MDAvatar from "@cloudpremise/portal_core/src/themes/mui/components/MDAvatar";
import { useAuthProvider } from "@cloudpremise/portal_core";

// @mui icons
import Icon from "@mui/material/Icon";

import Config from "./Config";
const cdnUrl = Config.getCdnUrl();

// Images
const profilePicture = cdnUrl + "/assets/images/team-3.jpg";

const menus = (props) => {
    const { pluginUserMenus, basename } = props;
    const [ authorized ] = useAuthProvider();
    const navigate = useNavigate();
    const userMenus = [];
    let deviderItem = [];
    if(authorized){
        userMenus.push({
            name: "Logout",
            key: "logout",
            route: "/logout",
            privacy: "private"
        });
        deviderItem.push({ type: "divider", key: "divider-0" });
    }
    const onElementNavigate = (event, target) => {
        event.preventDefault();
        let targetElement = document.querySelector(target);
        if(!targetElement){
            let url = '';
            if(event){
                url = event.currentTarget.getAttribute("href");
            }
            url = url.replace(basename, "");
            navigate(url);
            window.history.replaceState(null, document.title, basename+url+window.location.search);

            setTimeout(() => {
                targetElement = document.querySelector(target);
                window.scrollTo({ top: (targetElement.offsetTop + 20), behavior: 'smooth' });
            }, 100);
        }else{
            window.scrollTo({ top: (targetElement.offsetTop + 20), behavior: 'smooth' });
        }
    };
    return [
        // {
        //     type: "collapse",
        //     name: "Brooklyn Alice",
        //     key: "brooklyn-alice",
        //     icon: <MDAvatar src={profilePicture} alt="Brooklyn Alice" size="sm" />,
        //     privacy: "private",
        //     collapse: [
        //         ...pluginUserMenus,
        //         ...userMenus,
        //     ]
        // },
        // ...deviderItem,
        {
            type: "menu_item",
            name: "Who We Serve",
            key: "home",
            href: "/",
            privacy: "both",
            onClick: (event) => onElementNavigate(event, '.whoweserve-container')
        },
        {
            type: "menu_item",
            name: "Features",
            key: "features",
            href: "/",
            privacy: "both",
            onClick: (event) => onElementNavigate(event, '.intro-container')
        },
        {
            type: "collapse",
            name: "More",
            key: "more",
            privacy: "both",
            collapse: [
              {
                name: "Why Choose Us",
                key: "choose_us",
                href: "/",
                onClick: (event) => onElementNavigate(event, '.why-container')
              },
              {
                name: "Blogs",
                key: "blogs",
                route: "/blogs",
              },
            ],
        },
    ];
};

export default menus;
